import createPortalAttachment from '../PortalAttachment';

export default createPortalAttachment('HeaderAttachment');
